module.exports = __webpack_public_path__ + "static/img/banner.2f97729.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/brand/banner.png
// module id = QZC6
// module chunks = 0